/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineLocationService() {
        let locationService = {};
        locationService.sequenceOrdersBasedOnLocation = function (request) {
            return axios.post("/api/LocationService/SequenceOrdersBasedOnLocation", request);
        };
        return locationService;
    }
    //define globally if it doesn't already exist
    if (typeof (locationService) === "undefined") {
        window.locationService = defineLocationService();
    } else {
        console.log("locationService already defined.");
    }
})(window);